
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/festivals/[festivalId]/extras/[postId]",
      function () {
        return require("private-next-pages/festivals/[festivalId]/extras/[postId].tsx");
      }
    ]);
  